import React from 'react';
import cx from 'classnames';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { Button, Carousel } from '@m4b-design/components';
import { I18nRichText } from '@features/components/i18n-rich-text';
import { ReactComponent as EnterIcon } from '@/assets/imgs/icon_enter.svg';
import { LoginPanel } from '@/components';
import { useBanner } from './index.ViewHook';
import styles from './index.scss';

interface BannerProps {
  className?: string;
}

export const Banner = ({ className }: BannerProps) => {
  const { t } = useTranslation();
  const {
    isLogin,
    banners,
    placeholder,
    slogans,
    interval,
    handleCarouselChange,
    handleBannerClick,
  } = useBanner();
  const { open: openLoginPanel } = LoginPanel.useModal();

  return (
    <div className={cx(styles.Banner, className)}>
      <Carousel
        className={styles.BannerCarousel}
        indicatorType="line"
        moveSpeed={1000}
        animation="fade"
        autoPlay={{ interval: interval * 1000 }}
        showArrow="hover"
        arrowClassName="carouselArrow"
        onChange={handleCarouselChange}>
        <section key="default" className={styles.BannerDefault}>
          <div>
            <div className={styles.BannerDefaultSlogan}>
              {slogans.map(
                slogan =>
                  slogan && (
                    <p key={slogan}>
                      <I18nRichText noWrapper content={slogan}>
                        <span>{placeholder}</span>
                      </I18nRichText>
                    </p>
                  ),
              )}
            </div>
            <p className={styles.BannerDefaultDesc}>
              {t('academy_homepage_banner_slogan_03')}
            </p>
            {isLogin === 0 && (
              <Button
                className={styles.BannerDefaultBtn}
                type="primary"
                size="large"
                onClick={openLoginPanel}>
                {t('academy_homepage_banner_btn_login')}
                <EnterIcon />
              </Button>
            )}
          </div>
        </section>
        {banners.map(banner => (
          <section key={banner.image_url} className={styles.BannerList}>
            {banner.image_url && (
              <a
                href={banner.jump_url}
                onClick={() => handleBannerClick(banner)}
                target="_blank">
                <img
                  src={banner.image_url}
                  alt={'academy homepage banner image'}
                />
              </a>
            )}
          </section>
        ))}
      </Carousel>
    </div>
  );
};
